export const CURRENCIES = [
  { code: "USD", symbol: "$",  label: "US Dollar" },
  { code: "EUR", symbol: "€",  label: "Euro" },
  { code: "GBP", symbol: "£",  label: "British Pound" },
  { code: "INR", symbol: "₹",  label: "Indian Rupee" },
  { code: "JPY", symbol: "¥",  label: "Japanese Yen" },
  { code: "CAD", symbol: "C$", label: "Canadian Dollar" },
  { code: "AUD", symbol: "A$", label: "Australian Dollar" },
  { code: "CHF", symbol: "Fr", label: "Swiss Franc" },
  { code: "CNY", symbol: "¥",  label: "Chinese Yuan" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham" },
  { code: "SGD", symbol: "S$", label: "Singapore Dollar" },
  { code: "BRL", symbol: "R$", label: "Brazilian Real" },
];

export function formatMoney(amount, currency = "USD", { compact = false } = {}) {
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: compact && Math.abs(value) >= 1000 ? 0 : 2,
      notation: compact ? "compact" : "standard",
    }).format(value);
  } catch {
    const entry = CURRENCIES.find((c) => c.code === currency);
    return `${entry?.symbol || ""}${value.toFixed(2)}`;
  }
}

export function symbolFor(code) {
  return CURRENCIES.find((c) => c.code === code)?.symbol || code;
}
